import { render, staticRenderFns } from "./IntroVideoModalComponent.vue?vue&type=template&id=4ae94d53&"
import script from "./IntroVideoModalComponent.vue?vue&type=script&lang=js&"
export * from "./IntroVideoModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BRow, BContainer, BModal} from 'bootstrap-vue'
    installComponents(component, {BRow, BContainer, BModal})
    

export default component.exports